module.exports = __webpack_public_path__ + "img/bg_device_pc_big.61f903ad.svg";